import React from "react"; 
import { Link } from "react-router-dom";    
import EditAppUserForm from "../../../components/Dashboard/AppUsersListContent/Edit";

const EditAppUser = () => {
  return (
    <>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-card">
        <h5>Edit User</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>App Users</li>
          <li>Edit App User</li>
        </ul>
      </div> */}

      <EditAppUserForm />
    </>
  );
};

export default EditAppUser;
